import gql from "graphql-tag";

export const DELETE_INVOICE = gql`
  mutation ($invoiceId: ID!, $workspaceId: ID!) {
    deleteInvoice(invoiceId: $invoiceId, workspaceId: $workspaceId) {
      _id
    }
  }
`;
